import React from "react";
import {Button, ButtonGroup, Container, Flex, Grid, GridItem, Heading, Text} from "@chakra-ui/react";
import Portfolio from "./Portfolio";

function Headline(props) {
    return (
        <Container
            maxW={'7xl'}
            paddingX={0}
            paddingY={6}
            marginX={0}
        >
            <Grid
                h={'70vh'}
                templateRows='repeat(2, 1fr)'
                templateColumns='repeat(3, 1fr)'
                gap={4}
            >
                <GridItem rowSpan={2} colSpan={1} bg={'pink.100'} borderRadius={20} padding={3}
                          style={{zIndex: 10}}>
                    <Flex
                        textAlign={'start'}
                        height={'100%'}
                        flexDirection={'column'}
                        justifyContent={'space-evenly'}
                    >
                        <Heading fontSize={'6xl'}>
                            Bin nisl nisi scelerisque eu ultrices vitae
                        </Heading>
                        <Text fontSize={'xl'} lineHeight={8}>
                            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                        </Text>
                        <ButtonGroup>
                            <Button
                                size={'lg'}
                            >Lorem</Button>
                            <Button
                                size={'lg'}
                            >ipsum</Button>
                        </ButtonGroup>
                    </Flex>
                </GridItem>
                <GridItem
                    rowSpan={1}
                    colSpan={2}
                    bg={'gainsboro'}
                    borderRadius={20}
                >
                    <Portfolio/>
                </GridItem>
                <GridItem rowSpan={1} colSpan={1} bg={'beige'} borderRadius={20}
                          style={{zIndex: 20}}>

                </GridItem>
                <GridItem rowSpan={1} colSpan={1} bg={'bisque'} borderRadius={20}
                          style={{zIndex: 20}}/>
            </Grid>
        </Container>
    );
}

export default Headline;
